import { Box } from '@mui/material';
import React from 'react';
import {
  MemoStatefulSingleSelect,
  MemoStatefulAutocompleteWithText,
} from 'components/dataCreationForms/withInputForm/statefulInputsWrapper';
import { IssueFormPresentationalProps } from './types';

export function IssueFormPresentational(
  props: IssueFormPresentationalProps
): React.ReactElement {
  const {
    processFieldProps,
    siteFieldProps,
    titleFieldProps,
    levelFieldProps,
  } = props;

  return (
    <Box
      sx={{
        width: '100%',
        display: 'flex',
        flexFlow: 'column nowrap',
        gap: 2,
        '& .MuiFormControl-root': {
          width: '100%',
        },
      }}
    >
      <MemoStatefulSingleSelect {...processFieldProps} />
      <MemoStatefulSingleSelect {...siteFieldProps} />
      <MemoStatefulSingleSelect {...levelFieldProps} />
      <MemoStatefulAutocompleteWithText {...titleFieldProps} />
    </Box>
  );
}
